/* eslint-disable camelcase */
import PropTypes from "prop-types";

export const priceProp = PropTypes.shape({
    discount: PropTypes.number,
    discount_percentage: PropTypes.number.isRequired,
    discount_with_currency: PropTypes.string,
    new_product: PropTypes.bool.isRequired,
    on_sale: PropTypes.bool.isRequired,
    price_with_currency: PropTypes.string.isRequired,
    sale_price: PropTypes.number.isRequired,
    sale_price_with_currency: PropTypes.string,
});

export const saColorProp = PropTypes.shape({
    id: PropTypes.string,
    color_name: PropTypes.string,
    image: PropTypes.shape({
        height: PropTypes.string,
        width: PropTypes.string,
        url: PropTypes.string,
    }),
});

export const currentProductProp = PropTypes.shape({
    custom_attributes: PropTypes.shape({
        sa_color: saColorProp,
    }),
    sku: PropTypes.string,
    id: PropTypes.string,
    media: PropTypes.arrayOf(
        PropTypes.shape({
            alt: PropTypes.string,
            name: PropTypes.string,
            sizes: PropTypes.exact({
                original: PropTypes.shape({
                    url: PropTypes.string,
                }),
            }),
        }),
    ),
    price: PropTypes.shape({
        discount: PropTypes.number,
        price: PropTypes.number,
        sale_price_with_currency: PropTypes.string,
    }).isRequired,
    size: PropTypes.string,
    name: PropTypes.string,
    uri: PropTypes.string,
});

const productProp = PropTypes.shape({
    attributes: PropTypes.array,
    categories: PropTypes.array,
    categories_sort: PropTypes.object,
    collection: PropTypes.any,
    colors: PropTypes.array,
    content_data: PropTypes.any,
    custom_attributes: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    ean: PropTypes.any,
    flags: PropTypes.array,
    media: PropTypes.arrayOf(
        PropTypes.exact({
            alt: PropTypes.string,
            mime_type: PropTypes.string,
            name: PropTypes.string,
            sizes: PropTypes.exact({
                original: PropTypes.exact({
                    height: PropTypes.number,
                    url: PropTypes.string,
                    width: PropTypes.number,
                }),
            }),
            type: PropTypes.string,
        }),
    ),
    name: PropTypes.string,
    objectID: PropTypes.string,
    parent_id: PropTypes.string,
    id: PropTypes.string,
    price: priceProp,
    product_nr: PropTypes.number,
    promotion: PropTypes.array,
    related_variations: PropTypes.array,
    sku: PropTypes.string,
    status: PropTypes.any,
    uri: PropTypes.string,
    variations: PropTypes.array,
});

export default productProp;
